import { render, staticRenderFns } from "./MyTasks.vue?vue&type=template&id=6544e2f8&scoped=true"
import script from "./MyTasks.vue?vue&type=script&lang=js"
export * from "./MyTasks.vue?vue&type=script&lang=js"
import style0 from "./MyTasks.vue?vue&type=style&index=0&id=6544e2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6544e2f8",
  null
  
)

export default component.exports